import { decodeBase64Url } from './encode-base64';
import { CheckoutDataDecodeError, StatusDataDecodeError, toError } from './errors';
export function decodeCheckoutData(encoded) {
  try {
    return decodeBase64Url(encoded);
  } catch (err) {
    throw new CheckoutDataDecodeError(toError(err).message);
  }
}
export function decodeStatusData(encoded) {
  try {
    return decodeBase64Url(encoded);
  } catch (err) {
    throw new StatusDataDecodeError(toError(err).message);
  }
}
//# sourceMappingURL=decode-path-data.js.map